import { CrmFieldService, StandardIds } from '@galaxy/crm/services/field-service';
import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RxState } from '@rx-angular/state';
import { ActivityInterface } from '@vendasta/crm';
import { map } from 'rxjs';
import { CollapsibleSectionComponent } from '../../collapsible-section/collapsible-section.component';
import { TranslationModule } from '../../../i18n/translation-module';
import { ActivityRichTextComponent } from './activity-rich-text.component';

@Component({
  selector: 'crm-activity-logged-email',
  templateUrl: './logged-email.component.html',
  styleUrls: ['./logged-email.component.scss'],
  providers: [RxState],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule, TranslationModule, CollapsibleSectionComponent, ActivityRichTextComponent],
})
export class CrmActivityLoggedEmailComponent {
  @Input() set activity(activity: ActivityInterface) {
    this.state.set({ activity: activity });
  }
  get activity() {
    return this.state.get().activity;
  }

  @Input() showDirection = true;

  description$ = this.state.select('description');
  direction$ = this.state.select('direction');

  constructor(
    private readonly state: RxState<ComponentState>,
    private readonly fieldService: CrmFieldService,
  ) {
    this.state.set({
      activity: undefined,
      description: '',
      direction: '',
    });

    this.state.connect(
      'description',
      this.state
        .select('activity')
        .pipe(
          map(
            (activity) =>
              this.fieldService.getFieldValueFromCrmObject(activity, StandardIds.ActivityEmailBody)?.stringValue ?? '',
          ),
        ),
    );

    this.state.connect(
      'direction',
      this.state
        .select('activity')
        .pipe(
          map(
            (activity) =>
              this.fieldService.getFieldValueFromCrmObject(activity, StandardIds.ActivityEmailDirection)?.stringValue ??
              '',
          ),
        ),
    );
  }
}

interface ComponentState {
  activity: ActivityInterface;

  description: string;
  direction: string;
}
